import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const StyledHeaderButton = styled.div`
  display: inline-block;
  text-align: center;
  line-height: 30px;
  width: 30px;
  height: 30px;
  font-size: 16px;
  border-radius: 50%;
  cursor: pointer;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`

type Props = React.HTMLProps<HTMLDivElement> & {
  icon?: React.ReactElement
  className?: string
}

const HeaderButton = React.forwardRef<HTMLDivElement, Props>(({ children, icon, ...props }, ref) => (
  <StyledHeaderButton
    {...props}
    ref={ref}
  >
    {icon}
    {children}
  </StyledHeaderButton>
))

HeaderButton.displayName = 'HeaderButton'

HeaderButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.element
}

export default HeaderButton
